import moment from 'moment';
import { dateToISOString } from 'utils';

export const formatConversationTime = (time) => {
  const date = moment(time);
  let format = 'MMM D, GGGG';

  if (moment().isSame(date, 'day')) {
    format = 'LT';
  } else if (moment().diff(date, 'week') === 0) {
    format = 'ddd, LT';
  } else if (moment().isSame(date, 'year')) {
    format = 'MMM D';
  }

  return date.format(format);
};

export const getDayTime = (time) => moment(time).format('h:mm a');

export const formatMessageTime = (time) => {
  const date = moment(time);
  let format = 'h:mm a';

  if (moment().isSame(date, 'day')) {
    format = 'h:mm a';
  } else if (moment().isSame(date, 'week')) {
    format = 'ddd h:mm a';
  } else {
    format = 'MM/DD h:mm a';
  }

  return date.format(format);
};

export const formatGroupDate = (time) => {
  const date = moment(time);
  let format = 'dddd, MMM D, GGGG';

  if (moment().isSame(date, 'day')) {
    return 'Today';
  }

  if (moment().isSame(date, 'week')) {
    format = 'dddd';
  } else if (moment().isSame(date, 'year')) {
    format = 'MMM D';
  }

  return date.format(format);
};

export const formatExpiryDate = (time) => {
  const date = moment(time);
  const format = 'DD/MM/YY';

  return date.format(format);
};

/**
 * @param {number} bytes
 */
export const convertBytesToMB = (bytes) => {
  const M = 2 ** 20;
  const thousandthOfMegabyte = 0.001;
  if (typeof bytes !== 'number' || !bytes) return 0;
  // assuming for range 1 to 1050 bytes to use 0.001 MB precision
  return Math.max(parseFloat((bytes / M).toFixed(3)), thousandthOfMegabyte);
};

export const addAttachmentsNotificationMsg = (message) => ({
  id: `add-attachments-${Date.now()}`,
  message: message || 'Upload failed',
  type: 'error',
  direction: 'bottomCenter',
});

/**
 * @param {Array<File>} attachments
 * @returns {number}
 */
export const getAttachmentsSize = (attachments = []) =>
  attachments.reduce((totalSize, attachment) => {
    return totalSize + convertBytesToMB(attachment?.size);
  }, 0);

/**
 * @param {string} message
 * @param {Array<File>} attachments
 * @returns {number}
 */
export const getMessageSize = (message = '', attachments = []) => {
  const attachmentsSizeInMb = getAttachmentsSize(attachments);
  const messageSizeInBytes = new Blob([message]).size;
  const messageSizeInMb = convertBytesToMB(messageSizeInBytes);

  return Number((attachmentsSizeInMb + messageSizeInMb).toFixed(3));
};

export const mapMessageNotificationData = (payload, message = {}) => {
  const msg = payload.message || '';
  let msgBody;
  let mediaUrls;
  try {
    const parsedMessage = JSON.parse(msg);
    msgBody = parsedMessage?.body || '';
    mediaUrls = parsedMessage?.mediaUrls || [];
  } catch (err) {
    msgBody = msg;
  }
  const date = payload.date_created;
  // This is needed to fix timestamp that sometimes comes from BE as string, and causes "Invalid date" error.
  const timestampInMSLength = 13;
  const dateCreated = date?.length === timestampInMSLength ? dateToISOString(date) : date;

  return {
    ...message,
    messageId: payload.messageId || message.messageId,
    messageType: payload.message_type || message.messageType,
    messageStatus: payload.message_status?.toLowerCase() || message.messageStatus?.toLowerCase(),
    dateCreated: dateCreated || message.dateCreated,
    direction: payload.message_direction || message.direction,
    body: msgBody || message.body,
    subject: payload.message_subject || message.subject,
    mediaUrls: mediaUrls || message.mediaUrls,
  };
};

export const updateMessage = (data, payload) => {
  const oldMessage = data.find((message) => message.messageId === payload.messageId);
  const restMessages = data.filter((message) => message.messageId !== payload.messageId);

  return [mapMessageNotificationData(payload, oldMessage), ...restMessages];
};

export const markMessagesRead = (data, payload) => {
  return data.map((message) => {
    const isMarked = payload.find((m) => m.messageId === message.messageId);
    return !isMarked ? message : { ...message, messageStatus: 'read' };
  });
};
